module.exports = __webpack_public_path__ + "static/logo17-d9cf4e42c70735d50675afbda3b26868.png";